import React from 'react';
import { ProgressBarContainer } from './Styled';
import { ProgressBarProps } from '../../../types';

const ProgressBar = (props: ProgressBarProps) => {
  const { percentage, height, color, fullWidth } = props;

  return (
    <ProgressBarContainer theme={{ percentage, height, color, fullWidth }}>
      <div />
    </ProgressBarContainer>
  );
};

ProgressBar.defaultProps = {
  color: '#FAD70A',
  height: 12,
  percentage: 0,
};

export default ProgressBar;
export { ProgressBar };
